import * as React from 'react';
import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/Popover';

const PageHelpPopoverContext = React.createContext<{ close: () => void } | null>(null);

export function usePageHelpPopover(): () => void {
  return React.useContext(PageHelpPopoverContext)?.close ?? (() => {});
}

interface PageHelpPopoverProps {
  help: React.ReactNode;
  helpAnchorId?: string | null;
}

export function PageHelpPopover({ help, helpAnchorId }: PageHelpPopoverProps) {
  const [open, setOpen] = React.useState(false);
  const close = React.useCallback(() => setOpen(false), []);

  return (
    <PageHelpPopoverContext.Provider value={{ close }}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            id={helpAnchorId ?? undefined}
            variant="ghost"
            size="sm"
            className="h-9 w-9 p-0"
            aria-label="Page help"
          >
            <HelpCircle className="h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-[min(36rem,90vw)] max-w-none p-0 text-sm">
          <div className="max-h-[min(85vh,42rem)] overflow-y-auto p-4">{help}</div>
        </PopoverContent>
      </Popover>
    </PageHelpPopoverContext.Provider>
  );
}
